import { SpokePageSpinner } from '@doltech/core/lib/auth/SpokePageSpinner';
import dynamic from 'next/dynamic';
import * as React from 'react';

export const RelatedPostsDolVn = dynamic<any>(
  () => import('./RelatedPostsDolVnBase').then((mod) => mod.RelatedPostsDolVnBase),
  {
    loading: () => <SpokePageSpinner />,
    ssr: true,
  }
);
